import { h } from 'preact'

// Composant principal
export const BandeEquipements = ({ titleCategories, items, viewAllCategories, cacheKey }) => {
   return (
      <div class="container-fluid">
         <div class="bande-equipments row mb-2" data-testid="bande-equipements" data-cache-key={cacheKey}>
            <div class="col-12">
               <h2 class="mb-1 mb-xl-3 mw-100">{titleCategories}</h2>

               <ul class="row slider-eqpt list-unstyled mb-0">
                  {items.map((item, index) => (
                     <Equipement {...item} index={index + 1} />
                  ))}
               </ul>
               <a
                  class="cta-view-all o-link-arrow px-1 text-center mw-100"
                  href={viewAllCategories.URL}
                  data-testid="view-all-equipement"
                  data-oevent-category={viewAllCategories.analytics.oeventCategory}
                  data-oevent-action={viewAllCategories.analytics.oeventAction}
                  data-oevent-label={viewAllCategories.analytics.oeventLabel}
                  data-oevent-other={viewAllCategories.analytics.oeventOther}
               >
                  {viewAllCategories.label}
               </a>
            </div>
         </div>
      </div>
   )
}

// Element Equipement
const Equipement = ({ analytics, title, URL, image, alt, index, background, tag }) => {
   return (
      <li class="col-12 mb-2 col-md-3">
         <a
            href={URL}
            class={`item-equipement ${background}`}
            data-testid={`equipements${index}`}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="card-eqpt"></div>
            <div class="visuel">
               <img src={image} alt="" loading="lazy" />
            </div>
            {tag !== '' && <strong class="tag ob1-tag ob1-tag-primary">{tag}</strong>}
            <h3 class="lead title m-0 pt-2 p-0">{title}</h3>
         </a>
      </li>
   )
}
